/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
// import ChildTraining from "components/widgets/training/CompletedTraining";
import { connect } from "react-redux";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import requireAuth from "components/hoc/requireAuth";
import { Trans } from "react-i18next";
import i18n from "i18next";
import { getEmployees, jobTermination, hideModal } from "actions";
import toastr from "toastr";

class JobTermination extends Component {
  state = {
    selectedTerminationDate: new Date(),
    terminationDate: new Date().toISOString().substr(0,10)
  };

  componentDidMount() {}

  getEmployees = () => {
    this.props.getEmployees(this.onBegin, this.onSuccess, this.onError);
  };

  jobTermination() {
    if (
      this.state.selectedTerminationDate === null ||
      this.state.selectedTerminationDate === ""
    ) {
      toastr.error("termination date alanı boş bırakılamaz");
      return false;
    }

    let formData = {
      TerminationDate: this.state.selectedTerminationDate,
    };

    this.props.jobTermination(
      this.props.employee.id,
      formData,
      this.onBegin,
      this.onJobTerminationSuccess,
      this.onError
    );
  }

  onBegin = () => {
    this.props.onProcessBegin();
  };

  onError = (err) => {
    console.log(err);
    toastr.error(err.response.data.message);
    this.props.onProcessEnd();
  };

  onSuccess = () => {
    this.props.onProcessEnd();
  };

  onJobTerminationSuccess = (res) => {
    toastr.success(i18n.t("10570"));
    this.getEmployees();
    this.props.onProcessEnd();
    this.props.hideModal();
  };

  renderFormHeader() {
    return null;
  }

  renderFormBody() {
    return (
      <div>
        <span>
          <b>{this.props.employee.fullname}</b>
        </span>
        <p>
          <Trans desc="Lütfen işten çıkış tarihi giriniz">10568</Trans>
        </p>
        <form>
          <div className="form-row">
            <div className="form-group col-md-12">
              <label htmlFor="nterminationDateame">
                <Trans desc="İşten Çıkış Tarihi">10569</Trans>
              </label>
              <input
                type="date"
                className="form-control"
                id="terminationDate"
                defaultValue={this.state.terminationDate}
                onChange={(e) =>
                  this.setState({
                    selectedTerminationDate: new Date(e.currentTarget.value),
                  })
                }
              ></input>
            </div>
          </div>
        </form>
      </div>
    );
  }

  renderFormFooter() {
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <button
          className="btn-action btn-blue"
          onClick={() => this.jobTermination()}
        >
          <Trans desc="Gönder">10567</Trans>
        </button>
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.props.spinner}
        {this.renderFormHeader()}
        {this.renderFormBody()}
        {this.renderFormFooter()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps, {
  getEmployees,
  jobTermination,
  hideModal,
})(containsLongRunningProcess(requireAuth(JobTermination)));
